import { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { IImportTemplate } from 'APIPackage/ImportExportModule/interfaces/IImportTemplate';
import notificationStyles from 'CorePackage/NotificationModule/components/Notification.module.scss';

interface IImportNotificationProps {
  message: ReactNode;
  routeTo: string;
  importId: IImportTemplate['uploadId'] | undefined;
}

export const ImportNotification = ({ message, routeTo, importId }: IImportNotificationProps) => (
  <>
    {message}&nbsp;
    <Link to={routeTo} className={notificationStyles.NotificationLink}>
      {importId}
    </Link>
  </>
);
